/*
 * @Author: changdou.fe@bytedance.com
 * @Date: 2025-11-09 12:57:34
 * @LastEditors: changdou.fe@bytedance.com
 * @LastEditTime: 2025-12-03 11:15:58
 */
'use client';
import { Wallet } from 'lucide-react';
import DepositV2 from '@/components/exchange/depositV2';
import RiskModal from '@/components/risk-modal';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { useUserInfo } from '@/app/stores/useUserStore';

export default function CoDeposit() {
  const { t } = useTranslation();
  const userInfo = useUserInfo();
  const [modalOpen, setModalOpen] = useState(false);
  const [riskModalOpen, setRiskModalOpen] = useState(false);

  const handleDepositClick = () => {
    if (userInfo?.isWalletBlacklisted) {
      setRiskModalOpen(true);
    } else {
      setModalOpen(true);
    }
  };

  return (
    <>
      <Button
        className="rounded-lg px-3 max-md:hidden h-8 hover:translate-y-[-1px] transition-all duration-300"
        variant="default-outline"
        onClick={handleDepositClick}
        title={t('header.deposit')}
      >
        <Wallet className="w-4 h-4" />
        <span className='max-xl:hidden ml-1'>
          {t('header.deposit')}
        </span>
      </Button>
      <DepositV2 source="header" open={modalOpen} depositTab="spot" onClose={() => setModalOpen(false)} />
      <RiskModal open={riskModalOpen} onClose={() => setRiskModalOpen(false)} />
    </>
  );
}
